<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step5.step') }}</p>
        <h1 class="project-title" v-if="typeStep !== 'shade'">{{ Translator('soprasolar.project.step5.title') }}</h1>
        <h1 class="project-title" v-else>{{ Translator('soprasolar.project.step5.title_shade') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">
          <template v-if="typeStep === 'shade'">
            <div class="checkbox form-group">
              <input type="checkbox" id="final_frame" v-model="form.final_frame" @change="onChange()">
              <label for="final_frame" class="control-label">
                {{ Translator('soprasolar.project.step5.form.final_frame_label') }}
              </label>
            </div>
            <div class="form-group" v-if="form.final_frame" :class="{ 'is-error': errorFinalFrameFile}">
              <div class="form-label-container">
                <label for="final_frameFile" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.final_frame_file') }}
                  <span>({{ Translator('soprasolar.project.step5.form.final_frame_file_more') }})</span>
                </label>
              </div>
              <file-upload v-model="form.final_frame_file" @update="onChangeFinalFrame()" />
              <p class="form-error" v-if="errorFinalFrameFile" >{{ Translator('soprasolar.project.step5.form.final_frame_file_error') }}</p>
            </div>

            <div class="form-group">
              <div class="form-label-container">
                <label for="jibe_optimization" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.jibe_optimization.label') }}
                </label>
              </div>
              <div class="radios">
                <div class="radio">
                  <input class="radio-input" type="radio" id="jibe_optimization_yes" name="jibe_optimization" v-model="form.jibe_optimization" value="yes" required>
                  <label class="radio-label" for="jibe_optimization_yes">
                    <p class="radio-label-text">{{ Translator('soprasolar.project.step5.form.jibe_optimization.yes') }}</p>
                  </label>
                </div>
                <div class="radio">
                  <input class="radio-input" type="radio" id="jibe_optimization_no" name="jibe_optimization" v-model="form.jibe_optimization" value="no" required>
                  <label class="radio-label" for="jibe_optimization_no">
                    <p class="radio-label-text">{{ Translator('soprasolar.project.step5.form.jibe_optimization.no') }}</p>
                  </label>
                </div>
              </div>
            </div>
          </template>
          <template v-if="typeStep !== 'shade'">
            <div class="form-group">
              <div class="form-label-container">
                <label for="insulation_sealing" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.insulation_sealing.label') }}
                </label>
              </div>
              <select id="insulation_sealing" required class="form-control" v-model="form.insulation_sealing">
                <option value=""></option>
                <option value="bare_mineral_wool">{{ Translator('soprasolar.project.step5.form.insulation_sealing.bare_mineral_wool') }}</option>
                <option value="weldable_mineral_wool">{{ Translator('soprasolar.project.step5.form.insulation_sealing.weldable_mineral_wool') }}</option>
                <option value="polyurethane">{{ Translator('soprasolar.project.step5.form.insulation_sealing.polyurethane') }}</option>
                <option value="perlite">{{ Translator('soprasolar.project.step5.form.insulation_sealing.perlite') }}</option>
                <option value="cellular_glass">{{ Translator('soprasolar.project.step5.form.insulation_sealing.cellular_glass') }}</option>
                <option value="expanded_polystyrene">{{ Translator('soprasolar.project.step5.form.insulation_sealing.expanded_polystyrene') }}</option>
                <option value="dontknow">{{ Translator('soprasolar.project.step5.form.insulation_sealing.dontknow') }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="form-label-container">
                <label for="calepinage" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.calepinage.label') }}
                </label>
              </div>
              <div class="radios">
                <div class="radio">
                  <input class="radio-input" @change="onChange()" type="radio" id="calepinage_yes" name="calepinage" v-model="form.calepinage" value="yes" required>
                  <label class="radio-label" for="calepinage_yes">
                    <p class="radio-label-text">{{ Translator('soprasolar.project.step5.form.calepinage.yes') }}</p>
                  </label>
                </div>
                <div class="radio">
                  <input class="radio-input" @change="onChange()" type="radio" id="calepinage_no" name="calepinage" v-model="form.calepinage" value="no" required>
                  <label class="radio-label" for="calepinage_no">
                    <p class="radio-label-text">{{ Translator('soprasolar.project.step5.form.calepinage.no') }}</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="form.calepinage === 'yes'" :class="{ 'is-error': errorCalipageFile}">
              <div class="form-label-container">
                <label for="calepinageFile" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.calepinage_file') }}
                  <span>({{ Translator('soprasolar.project.step5.form.calepinage_file_more') }})</span>
                </label>
                <help v-if="locale === 'en'" :image="'/assets/soprasolar/images/project/help-calepinage-en.png'" />
                <help v-else :image="'/assets/soprasolar/images/project/help-calepinage.png'" />
              </div>
              <file-upload v-model="form.calepinageFile" @update="onChangeCalipage()" />
              <p class="form-error" v-if="errorCalipageFile" >{{ Translator('soprasolar.project.step5.form.calepinage_file_error') }}</p>
            </div>
            <div class="form-group" v-if="datas.step3.photovoltaic_process !== 'light_reflection'">
              <div class="form-label-container">
                <label for="module" class="control-label required">
                  {{ Translator('soprasolar.project.step5.form.modules_choices.label') }}
                </label>
              </div>
              <select id="module" required class="form-control" v-model="form.modules_choices">
                <option value=""></option>
                <option value="longi_415_450">{{ Translator('soprasolar.project.step5.form.modules_choices.longi_415_450') }}</option>
                <option value="dualsun_410">{{ Translator('soprasolar.project.step5.form.modules_choices.dualsun_410') }}</option>
                <option value="voltec_VSMP_435_460">{{ Translator('soprasolar.project.step5.form.modules_choices.voltec_VSMP_435_460') }}</option>
                <option value="voltec_VSBP_435_460">{{ Translator('soprasolar.project.step5.form.modules_choices.voltec_VSBP_435_460') }}</option>
                <option value="voltec_s110_rVSBP_455_485">{{ Translator('soprasolar.project.step5.form.modules_choices.voltec_s110_rVSBP_455_485') }}</option>
                <option value="longi_455_470">{{ Translator('soprasolar.project.step5.form.modules_choices.longi_455_470') }}</option>
                <option value="longi_475_490">{{ Translator('soprasolar.project.step5.form.modules_choices.longi_475_490') }}</option>
                <option value="longi_475_495">{{ Translator('soprasolar.project.step5.form.modules_choices.longi_475_495') }}</option>
                <option value="dmegc_hbw_hbt_435_460">{{ Translator('soprasolar.project.step5.form.modules_choices.dmegc_hbw_hbt_435_460') }}</option>
                <option value="dmegc_hbw_hbt_450_475">{{ Translator('soprasolar.project.step5.form.modules_choices.dmegc_hbw_hbt_450_475') }}</option>
                <option value="jinko_445_485_DB">{{ Translator('soprasolar.project.step5.form.modules_choices.jinko_445_485_DB') }}</option>
                <option value="jinko_445_485_DV">{{ Translator('soprasolar.project.step5.form.modules_choices.jinko_445_485_DV') }}</option>
                <option value="jinko_445_485_BDV">{{ Translator('soprasolar.project.step5.form.modules_choices.jinko_445_485_BDV') }}</option>
                <option value="other">{{ Translator('soprasolar.project.step5.form.modules_choices.other') }}</option>
                <option value="dontknow">{{ Translator('soprasolar.project.step5.form.modules_choices.dontknow') }}</option>
              </select>
            </div>
            <div class="form-group" v-if="form.modules_choices === 'other'">
              <input type="text" required id="modules_choices_other" :placeholder="Translator('soprasolar.project.step5.form.modules_choices_other')" class="form-control" v-model="form.modules_choices_other">
            </div>
          </template>
          <div class="form-group">
            <div class="form-label-container">
              <label class="control-label">
                <span>{{ Translator('soprasolar.project.step5.form.files') }}<br></span>
                <template v-if="datas.step0 && datas.step0.type === 'terrace'">
                  <span>({{ Translator('soprasolar.project.step5.form.files_more_terrace') }})</span><br>
                  <span v-html="Translator('soprasolar.project.step5.form.files_terrace')"></span>
                </template>
                <template v-if="datas.step0 && datas.step0.type === 'shade'">
                  <span>({{ Translator('soprasolar.project.step5.form.files_more_shade') }})</span><br>
                  <span v-html="Translator('soprasolar.project.step5.form.files_shade')"></span>
                </template>
              </label>
            </div>

            <div v-for="(file, index) in files" :key="index" >
              <file-upload v-model="files[index]" @update="onUpdateLoopFile($event, index)" />
            </div>
            <button type="button" @click="onAddFile" class="button-add" v-if="isAllFilesCompleted">
              <i class="ic ic-add"></i>
              {{ Translator('soprasolar.project.step5.add_file') }}
            </button>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="comment" class="control-label">
                {{ Translator('soprasolar.project.step5.form.comment') }}
              </label>
            </div>
            <textarea id="comment" class="form-control" :placeholder="Translator('soprasolar.project.step5.form.' + ( typeStep === 'shade' ? 'comment_shade_placeholder' : 'comment_terrace_placeholder'))" v-model="form.comment"></textarea>
          </div>

          <div class="checkbox form-group">
            <input type="checkbox" id="rgpd" v-model="form.rgpd" required>
            <label for="rgpd" class="control-label required">
              {{ Translator('soprasolar.project.step5.form.rgpd') }}
            </label>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .project-wrapper {
    @include vertical-spacing-inner-top;
  }
  .button-add {
    @include resetBtn;
    display: inline-block;
    color: $color-main;
    padding-top: rem(10);
    padding-bottom: rem(10);
    font-size: rem(14);
    .ic {
      vertical-align: middle;
      margin-right: rem(5);
      font-size: rem(22);
    }
  }
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';
import Save from '@/soprasolar-project/components/Save';
import FileUpload from '@/soprasolar-project/components/File-upload';
import Help from '@/soprasolar-project/components/Help';

export default {
  name: 'step-5',
  components: {
    Save,
    FileUpload,
    Help
  },
  props: ['typeStep'],
  data () {
    return {
      datas: AppControlService.datas,
      errorFinalFrameFile: false,
      errorCalipageFile: false,
      isLoading: false,
      form: {},
      isAllFilesCompleted: true,
      files: [],
      locale: window.Translator.locale,
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step5) this.form = this.datas.step5;
    if(!this.form.files) this.form.files = [];
    this.files = this.form.files;
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      this.errorCalipageFile = false;
      this.errorFinalFrameFile = false;
      if(this.form.final_frame && !this.form.final_frame_file) {
        setTimeout(() => {
          this.errorFinalFrameFile = true;
        });
        return;
      }
      if(this.form.calepinage === 'yes' && !this.form.calepinageFile) {
        setTimeout(() => {
          this.errorCalipageFile = true;
        });
        return;
      }
      if(!this._form.isValidate) return;
      if(this.isLoading) return;
      for( let i = this.form.files.length - 1; i >= 0; i-- ) {
        if(!this.form.files[i]) this.form.files.splice(i, 1);
      }
      this.isLoading = true;
      AppControlService.update('step5', this.form).then( () => {
        AppControlService.goToNextStep();
      }).catch(console.error).then(() => {
        this.isLoading = false;
      })
    },

    onChangeFinalFrame() {
      this.errorFinalFrameFile = this.form.final_frame && !this.form.final_frame_file;
    },

    onChangeCalipage() {
      this.errorCalipageFile = this.form.calepinage === 'yes' && !this.form.calepinageFile;
    },

    onChange() {
      this._form._formGrabDom();
    },

    onUpdateLoopFile(datas, index) {
      if(!datas) {
        this.form.files.splice(index, 1);
        this.files = this.form.files;
      }
      this.checkAllFiles();
    },

    onAddFile() {
      this.form.files.push(null);
      this.files = this.form.files;
      this.checkAllFiles();
    },

    onClearFile(index) {
      this.form.files.splice(index, 1);
      this.files = this.form.files;
      this.checkAllFiles();
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    checkAllFiles() {
      this.isAllFilesCompleted = true;
      this.files.forEach(file => {
        if(!file) this.isAllFilesCompleted = false;
      });
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step5) this.form = this.datas.step5;
    }
  }
};
</script>